import { render, staticRenderFns } from "./RoleSignatures.vue?vue&type=template&id=1fec7dd7&scoped=true&"
import script from "./RoleSignatures.vue?vue&type=script&lang=js&"
export * from "./RoleSignatures.vue?vue&type=script&lang=js&"
import style0 from "./RoleSignatures.vue?vue&type=style&index=0&id=1fec7dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec7dd7",
  null
  
)

export default component.exports